import { Box, Button, Grid, GridItem, Heading, Icon } from '@everlywell/ui-kit';
import { Basket } from '@phosphor-icons/react';
import useCart from 'components/Cart/Cart.hooks';
import { Link } from 'gatsby';
import React from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { LineItem } from 'utils/types';

export type CartEmptyStateProps = {};

/**
 * Cart Empty State component.
 */
function CartEmptyState(props: CartEmptyStateProps): JSX.Element | null {
  const { closeCart } = useCart();

  const trackButtonClick = (buttonName: string, lineItem?: LineItem) => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: `${buttonName} button`,
        product: lineItem?.product_name,
      },
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={8}
      paddingX={4}
      paddingTop={12}
      paddingBottom={10}
      background="tints.lightCream"
      borderRadius={12}
      border="1px solid rgba(204, 204, 204, 0.80)"
    >
      <Box
        display="flex"
        flexDirection="column"
        gap="2"
        textAlign="center"
        alignItems="center"
      >
        <Icon as={Basket} color="viridian.base" size="lg" />
        <Heading as="p" size="md">
          Your cart is empty
        </Heading>
      </Box>
      <Grid spacing={3} alignEdges>
        <GridItem width={[1]}>
          <Button
            as={Link}
            to="/products"
            variant="primary"
            size="wide"
            onClick={() => {
              trackButtonClick('Shop all tests');
              closeCart();
            }}
          >
            Shop all tests
          </Button>
        </GridItem>
        <GridItem width={[1]}>
          <Button
            as={Link}
            to="/monthly-at-home-lab-testing-membership"
            variant="secondary"
            size="wide"
            onClick={() => {
              trackButtonClick('Discover Everlywell+');
              closeCart();
            }}
          >
            Discover Everlywell+
          </Button>
        </GridItem>
      </Grid>
    </Box>
  );
}

export default CartEmptyState;
